// ── The ladder ────────────────────────────────────────────────────────────────
// NextEp 17's one achievement system. One number (episodes you've marked), one
// ladder of named levels, always a next rung in view. Replaces the 16.x grid of
// badges, cards and keepsakes: those asked you to collect; this asks you to keep
// watching, which is the thing the app is for. Pure: no React, no storage.
//
// Levels are cumulative episode counts. The names are the job titles of a life
// spent in front of a television, in the order you'd earn them.

export const LADDER = [
  { at: 1,    name: 'Pilot',        line: 'One episode down. It starts here.' },
  { at: 10,   name: 'Regular',      line: 'Ten in. You have a show now.' },
  { at: 25,   name: 'Season Pass',  line: 'A whole season’s worth.' },
  { at: 50,   name: 'Binger',       line: 'Fifty. The couch has a dent.' },
  { at: 100,  name: 'Marathoner',   line: 'A hundred episodes marked.' },
  { at: 250,  name: 'Completist',   line: 'Two hundred and fifty. Finales fear you.' },
  { at: 500,  name: 'Archivist',    line: 'Five hundred. That’s a library.' },
  { at: 1000, name: 'Legend',       line: 'A thousand episodes. Say it out loud.' },
  { at: 2500, name: 'Hall of Fame', line: 'Twenty-five hundred. There is no level after this. Yet.' },
]

// Where a count sits on the ladder.
//   level: the highest rung reached (or null before the first episode)
//   next:  the rung above (null at the top)
//   toGo:  episodes until `next`
//   pct:   0..1 progress from `level.at` (or 0) to `next.at`
export function ladderFor(episodes) {
  const n = Math.max(0, Math.floor(Number(episodes) || 0))
  let level = null, next = LADDER[0]
  for (const rung of LADDER) {
    if (n >= rung.at) level = rung
    else { next = rung; break }
    next = null
  }
  const base = level ? level.at : 0
  const span = next ? next.at - base : 1
  const pct = next ? Math.min(1, Math.max(0, (n - base) / span)) : 1
  return { episodes: n, level, next, toGo: next ? next.at - n : 0, pct }
}

// The rung a move from `before` to `after` episodes crossed, if any (the highest one).
export function rungCrossed(before, after) {
  const b = Math.max(0, Number(before) || 0), a = Math.max(0, Number(after) || 0)
  if (a <= b) return null
  let crossed = null
  for (const rung of LADDER) if (rung.at > b && rung.at <= a) crossed = rung
  return crossed
}
